import React from "react";
import {Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Button} from "@material-ui/core";
import {notEmpty, validEmail} from "../helpers/Validator";
import Rest from "../helpers/Rest";

function Field({dialog, name, errorMessage, ...props}){
    return <Grid item xs={12}>
        <TextField
            variant="outlined"
            name={name}
            value={dialog.state[name]}
            onChange={dialog.update}
            fullWidth
            {...props}
        />
    </Grid>
}

export default class extends React.Component{
    constructor(props) {
        super(props)
        this.state = {
            name: "",
            email: "",
            issue: ""
        }

        this.update = e => this.setState({
            [e.target.name]: e.target.value
        })

        this.send = () => {
            Rest.post("public/report_issue", {
                qr_code: this.props.qrCode,
                ...this.state
            }).then(
                reply => this.props.onSent(reply)
            ).catch(
                error => this.props.onError(error)
            )
            this.props.onClose()
        }
    }

    get valid(){
        return notEmpty(this.state.name) && notEmpty(this.state.email) && validEmail(this.state.email)
    }

    render(){
        const {qrCode, onClose, onSent, onError, ...props} = this.props
        return <Dialog {...props} maxWidth="xs">
            <DialogTitle>Report an issue</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Field
                        dialog={this}
                        name="name"
                        label="Name"
                    />
                    <Field
                        dialog={this}
                        name="email"
                        label="Email"
                    />
                    <Field
                        dialog={this}
                        name="issue"
                        label="Issue"
                        rows={4}
                        multiline
                    />
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    disabled={!this.valid}
                    onClick={this.send}
                >Post</Button>
            </DialogActions>
        </Dialog>
    }
}
